<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="选择会员：" prop="member_code">
                <el-select v-model="model.member_code" placeholder="请选择" @change="memberChange" style="width: 180px" filterable>
                    <el-option v-for="item in promotionMemberList" :key="'m'+item.id" :label="item.name" :value="item.member_id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <el-input v-model="model.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <el-input v-model="model.cellphone" disabled></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" prop="goods_name">
                <el-select v-model="model.goods_name" placeholder="请选择" @change="goodsChange" style="width: 100%" filterable>
                    <el-option v-for="item in goodsList" :key="'g'+item.id" :label="item.title" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="佣金比例(%)：" prop="commission_tuan">
                <el-input v-model.number="model.commission_tuan" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_time">
                <el-date-picker v-model="model.start_time" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
                <el-date-picker v-model="model.end_time" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px"></el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { allGoods, allPromotionMember } from '@/api/promotiondao'
import { saveModel } from '@/api/common'

export default {
    name: 'promotionGoodsEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                commission_tuan: '',
                goods_id: '',
                goods_name: '',
                start_time: '',
                end_time: '',
                state: '',
                creator_id: '',
            },
            getObj:{
                url:'/api/admin/promotiongoods/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            promotionMemberList: [],
            goodsList: [],
            rules: {
                member_id: [
                    {required: true, message: '会员信息不能为空', trigger: 'blur'}
                ],
                member_code: [
                    {required: true, message: '会员信息不能为空', trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '会员信息不能为空', trigger: 'blur'}
                ],
                cellphone: [
                    {required: true, message: '会员信息不能为空', trigger: 'blur'}
                ],
                goods_id: [
                    {required: true, message: '商品信息不能为空', trigger: 'blur'}
                ],
                goods_name: [
                    {required: true, message: '商品信息不能为空', trigger: 'blur'}
                ],
                commission_tuan: [
                    {required: true, message: '团购佣金比例不能为空', trigger: 'blur'},
                    {type: 'number', message: '团购佣金比例必须是数字值', trigger: 'blur'}
                ],
                start_time: [
                    {required: true, message: '开始时间不能为空', trigger: 'blur'}
                ],
                end_time: [
                    {required: true, message: '结束时间不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        loadOtherData() {
            allGoods().then(res=>{
                if(res.code == 1){
                    this.goodsList = res.data
                }
            })
            allPromotionMember().then(res=>{
                if(res.code == 1){
                    this.promotionMemberList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/promotiongoods/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        memberChange(e){
            this.model.member_id = e
            for(let i=0; i<this.promotionMemberList.length;i++){
                if(e == this.promotionMemberList[i].member_id){
                    this.model.member_code = this.promotionMemberList[i].member_code
                    this.model.name = this.promotionMemberList[i].name
                    this.model.cellphone = this.promotionMemberList[i].cellphone
                    break;
                }
            }
        },
        goodsChange(e){
            this.model.goods_id = e
            for(let i=0; i<this.goodsList.length;i++){
                if(e == this.goodsList[i].id){
                    this.model.goods_name = this.goodsList[i].title
                    this.model.commission_tuan = this.goodsList[i].commission_tuan
                    break;
                }
            }
        },
    }
};
</script>